import { render, staticRenderFns } from "./TermModules.vue?vue&type=template&id=037b0e20"
import script from "./TermModules.vue?vue&type=script&lang=js"
export * from "./TermModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports